import classNames from 'classnames';
import type { ReactElement, Ref, RefObject } from 'react';
import { useRef } from 'react';
import { useChangeTransitionState } from 'util/react-transition-component/hooks/useChangeTransitionState';
import { useTransitionController } from 'util/react-transition-component';
import { renderCta } from 'util/cta/cta.template';
import type { CtaRefType } from 'util/cta/cta.data';
import styles from './IconButton.module.scss';
import { setupTransitionInTimeline, setupTransitionOutTimeline } from './IconButton.transitions';
import type { IconButtonProps, IconButtonRef } from './IconButton.data';
import Icon from '../icon/Icon';

export default function IconButton({
  isVisible,
  ref,
  ...props
}: IconButtonProps & { ref?: Ref<IconButtonRef> }): ReactElement {
  const localRef = useRef<CtaRefType>(undefined);
  const elementRef = (ref || localRef) as RefObject<CtaRefType | null>;

  const transitionController = useTransitionController(
    () => ({
      ref: elementRef,
      refs: {
        elementRef,
      },
      setupTransitionInTimeline,
      setupTransitionOutTimeline,
    }),
    [],
  );

  useChangeTransitionState(transitionController, isVisible);

  return renderCta({
    innerTemplate: <Icon name={props.icon} className={classNames(styles.icon)} transparent />,
    props: {
      ...props,
      className: classNames(styles.iconButton, props.className),
    },
    elementRef,
  });
}
